import * as React from 'react';

export function WhyFresh() {
  return (
    <section className="bp-fresh">
      <style>{`
        .bp-fresh {
          padding: 72px 24px;
          background: #fff;
        }
        .bp-fresh-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .bp-fresh h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          line-height: 1.3;
        }
        .bp-fresh .accent {
          font-size: 22px;
          font-weight: 600;
          color: #1EAA25;
          margin: 0 0 28px;
        }
        .bp-fresh p {
          font-size: 16px;
          color: #444;
          line-height: 1.7;
          margin: 0 0 20px;
        }
        .bp-fresh .highlight {
          font-weight: 600;
          color: #1a1a1a;
        }
        .bp-fresh-list {
          list-style: none;
          padding: 0;
          margin: 24px 0 0;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
        }
        .bp-fresh-list li {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 15px;
          color: #333;
          padding: 10px 14px;
          background: #f0fdf0;
          border-radius: 8px;
        }
        .bp-fresh-list li i {
          color: #1EAA25;
          font-size: 14px;
          flex-shrink: 0;
        }
        @media (max-width: 640px) {
          .bp-fresh h2 {
            font-size: 24px;
          }
          .bp-fresh-list {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
      <div className="bp-fresh-inner">
        <h2>Tu familia merece comer fresco de verdad.</h2>
        <p className="accent">No lo que sobró en la góndola.</p>
        <p>
          La diferencia entre una fruta del Mercado de Abasto y una de supermercado es enorme.
          <span className="highlight"> Se nota en el sabor, en la duración y en las ganas de comerla</span>.
        </p>
        <p>
          Cuando la fruta es rica, <span className="highlight">tus hijos la comen solos</span>.
          Y la verdura dura el doble en la heladera.
        </p>
        <ul className="bp-fresh-list">
          <li><i className="fa fa-check-circle" /> Productos que duran más en tu heladera</li>
          <li><i className="fa fa-check-circle" /> Sabor real, no de cámara frigorífica</li>
          <li><i className="fa fa-check-circle" /> Tus hijos comen más fruta cuando es rica</li>
          <li><i className="fa fa-check-circle" /> Menos desperdicio, más aprovechamiento</li>
        </ul>
      </div>
    </section>
  );
}
